import React from "react"
import { Card, Typography, Switch, Flex } from "antd"
import styles from "../index.module.css"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

const { Title, Text } = Typography

const CardProcessingFeeCard = ({ passFeeToGuest, onToggle, isLoading, isSaving }) => {
  const { t } = useTranslation()

  return (
    <Card className={styles.cardContainer}>
      <div className={styles.headerRow}>
        <div className={styles.titleWithInfo}>
          <Title level={4}>{t("settings.credit_card_fee_title")}</Title>
        </div>
      </div>
      <Text className={styles.description}>{t("settings.credit_card_fee_desc")}</Text>

      <Flex align="center" justify="space-between" className={styles.creditCardFeeRow}>
        <div>
          <Text className={styles.platformRadioLabel}>{t("settings.credit_card_fee_pass_to_guest")}</Text>
          <div className={styles.platformRadioDesc}>{t("settings.credit_card_fee_pass_to_guest_desc")}</div>
        </div>
        <Switch checked={passFeeToGuest} onChange={onToggle} disabled={isLoading} loading={isSaving} />
      </Flex>
    </Card>
  )
}

CardProcessingFeeCard.propTypes = {
  passFeeToGuest: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool
}

export default CardProcessingFeeCard
